import { Heading } from '@afterpaytouch/core'
import { useTranslation } from '../../utils/convergence'
import React, { useEffect } from 'react'
import { Head } from '../../../src/component'
import { NewShippingAddressForm } from '../../../src/component/NewShippingAddressForm/NewShippingAddressForm'
import { Route } from '../../../src/config/router'
import { TrackPageViewed } from '../../../src/integrations/monitoring'
import { CheckoutPage } from '../../../src/model'
import { useCheckoutSizes } from '../../../src/utils/responsive'
import { useAppRouter } from '../../../src/state'

export const NewShippingAddressPage: CheckoutPage = () => {
  const { t } = useTranslation()
  const { headingSize } = useCheckoutSizes()
  const router = useAppRouter()

  const pageTitle = `${t('shippingAddress:addNewShippingAddress')} | ${t('common:brandName')}`

  useEffect(() => {
    router.prefetch(Route.SHIPPING_ADDRESS)
  }, [])

  return (
    <>
      <Head title={pageTitle} />
      <Heading size={headingSize}>{t('shippingAddress:addNewShippingAddress')}</Heading>
      <NewShippingAddressForm />
      <TrackPageViewed />
    </>
  )
}
